export default __webpack_public_path__ + "static/media/bg-onb-left.1d4deca1.svg";